export default __webpack_public_path__ + "5a96a9b1500f9e1f204f92f540459c0a.png";